import React from "react";
import Input from "components/General/Form/Input";
import "components/General/Form/Address/Address.css";
import TextTheme from "components/General/Text/TextTheme";

class Address extends React.Component {
  render() {
    return (
      <form>
        <div className="project-form-address">
          <TextTheme
            message="1. Charitable Organization"
            className="mt-30 text_small text_black"
          />
          <Input
            type="text"
            name="name"
            placeholder="Name"
            value={this.props.name}
            handleChange={this.props.changeHandler}
          />
          {!this.props.hasName ? (
            <TextTheme
              message="Please enter name of the organisation"
              className="mt-1 text_small text_red"
            />
          ) : null}
          <Input
            type="text"
            name="address"
            placeholder="Address"
            value={this.props.address}
            handleChange={this.props.changeHandler}
          />
          {!this.props.hasAddress ? (
            <TextTheme
              message="Please enter the address"
              className="mt-1 text_small text_red"
            />
          ) : null}
          <div className="d-flex input-box">
            <div className="input-content">
              <Input
                type="text"
                name="city"
                placeholder="City"
                value={this.props.city}
                handleChange={this.props.changeHandler}
              />
              {!this.props.hasCity ? (
                <TextTheme
                  message="Please enter city name"
                  className="mt-1 text_small text_red"
                />
              ) : null}
            </div>
            <div className="input-content">
              <Input
                type="text"
                name="stateName"
                value={this.props.stateName}
                placeholder="State"
                handleChange={this.props.changeHandler}
              />
              {!this.props.hasStateName ? (
                <TextTheme
                  message="Please enter state name"
                  className="mt-1 text_small text_red"
                />
              ) : null}
            </div>
          </div>
          <Input
            type="text"
            name="website"
            placeholder="Website"
            value={this.props.website}
            handleChange={this.props.changeHandler}
          />
        </div>
      </form>
    );
  }
}

export default Address;
